(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opoflow-constitution-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nodes = document.querySelectorAll('[data-opo-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    nodes.forEach(function (n) { io.observe(n); });
  })();

  /* Comparador BOE ↔ visual.
     El range nativo se conserva por accesibilidad de teclado, pero en táctil
     obliga a acertar y arrastrar con precisión. Los eventos de puntero dan
     manipulación directa: el corte sigue al dedo desde donde lo pongas.
     `touch-action: pan-y` deja el scroll vertical intacto. */
  (function () {
    document.querySelectorAll('[data-opo-compare]').forEach(function (root) {
      var range = root.querySelector('[data-opo-cmp-range]');
      if (!range) return;

      function setPos(pct) {
        var value = Math.max(0, Math.min(100, pct));
        root.style.setProperty('--opo-pos', value + '%');
        range.value = String(Math.round(value));
      }

      function fromEvent(event) {
        var rect = root.getBoundingClientRect();
        if (!rect.width) return;
        setPos(((event.clientX - rect.left) / rect.width) * 100);
      }

      range.addEventListener('input', function () { setPos(Number(range.value)); });

      var dragging = false;
      root.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        root.setPointerCapture(event.pointerId);
        root.classList.add('is-dragging');
        fromEvent(event);
      });
      root.addEventListener('pointermove', function (event) {
        if (dragging) fromEvent(event);
      });
      function stop(event) {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        if (root.hasPointerCapture(event.pointerId)) root.releasePointerCapture(event.pointerId);
      }
      root.addEventListener('pointerup', stop);
      root.addEventListener('pointercancel', stop);

      setPos(Number(range.value));
    });
  })();

  /* Índice: abierto en escritorio, plegado en móvil. Se renderiza abierto para
     que sin JavaScript el contenido siga completo. */
  (function () {
    var blocks = document.querySelectorAll('[data-opo-collapsible]');
    if (!blocks.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      blocks.forEach(function (el) {
        // en móvil se cierran todos: 45 filas seguidas son ilegibles en un
        // teléfono, y tres cabeceras dejan ver la estructura de un vistazo
        el.open = !mq.matches;
      });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  })();

  /* Barra de compra fija: aparece cuando el CTA del hero deja de verse. */
  (function () {
    var bar = document.querySelector('[data-opo-stickybuy]');
    var anchor = document.querySelector('.opo-buy');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  })();

  /* Cuenta atrás del precio de lanzamiento. */
  (function () {
    document.querySelectorAll('[data-opo-countdown]').forEach(function (root) {
      var target = Date.parse(root.getAttribute('data-opo-countdown'));
      if (isNaN(target)) return;
      var d = root.querySelector('[data-opo-d]');
      var h = root.querySelector('[data-opo-h]');
      var m = root.querySelector('[data-opo-m]');
      var s = root.querySelector('[data-opo-s]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = target - Date.now();
        if (left <= 0) { root.hidden = true; clearInterval(id); return; }
        var secs = Math.floor(left / 1000);
        d.textContent = pad(Math.floor(secs / 86400));
        h.textContent = pad(Math.floor((secs % 86400) / 3600));
        m.textContent = pad(Math.floor((secs % 3600) / 60));
        s.textContent = pad(secs % 60);
        root.hidden = false;
      }
      tick();
      var id = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opoflow-sales-home"] && !Shopify.designMode) return;
  try {
    
  /* Muestra: apertura voluntaria; la descarga original funciona sin JavaScript. */
  (function () {
    document.querySelectorAll('[data-opo-sample-dialog]').forEach(function (dialog) {
      if (dialog.dataset.sampleBound || typeof dialog.showModal !== 'function') return;
      dialog.dataset.sampleBound = 'true';
      var trigger = document.querySelector('[data-opo-sample-open="' + dialog.id + '"]');
      var opener;
      var sampleForm = dialog.querySelector('form');
      var progress = dialog.querySelector('[data-opo-sample-progress]');
      var submitButton = dialog.querySelector('[data-opo-sample-submit]');
      var progressTimer;
      function resetProgress() {
        clearTimeout(progressTimer);
        if (sampleForm) sampleForm.removeAttribute('aria-busy');
        if (progress) { progress.hidden = true; progress.textContent = ''; }
        if (submitButton) submitButton.textContent = 'Suscribirme y acceder al PDF';
      }
      if (sampleForm && progress) {
        sampleForm.addEventListener('submit', function () {
          clearTimeout(progressTimer);
          sampleForm.setAttribute('aria-busy', 'true');
          progress.hidden = false;
          progress.textContent = 'Enviando tu solicitud. La descarga aparecerá al completar la suscripción.';
          if (submitButton) submitButton.textContent = 'Enviando solicitud…';
          progressTimer = setTimeout(function () {
            progress.textContent = 'La solicitud sigue en curso. Si aparece una comprobación de seguridad, complétala para continuar.';
          }, 12000);
        });
        sampleForm.addEventListener('invalid', resetProgress, true);
        window.addEventListener('pageshow', resetProgress);
      }
      if (trigger) dialog.querySelectorAll('a[href]').forEach(function (link) {
        if (link.href !== trigger.href) return;
        link.addEventListener('click', function () {
          dialog.close();
          var notice = trigger.parentElement.querySelector('[data-opo-sample-notice]');
          if (notice) notice.hidden = false;
        });
      });
      if (trigger) trigger.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); opener = trigger; dialog.showModal();
      });
      dialog.querySelector('[data-opo-sample-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () { if (opener) opener.focus({preventScroll:true}); });
      if (dialog.querySelector('[data-opo-sample-result]')) dialog.showModal();
    });
  })();

  (function () {
    var nodes = document.querySelectorAll('[data-opo-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    nodes.forEach(function (n) { io.observe(n); });
  })();

  /* Comparador BOE ↔ visual.
     El range nativo se conserva por accesibilidad de teclado, pero en táctil
     obliga a acertar y arrastrar con precisión. Los eventos de puntero dan
     manipulación directa: el corte sigue al dedo desde donde lo pongas.
     `touch-action: pan-y` deja el scroll vertical intacto. */
  (function () {
    document.querySelectorAll('[data-opo-compare]').forEach(function (root) {
      var range = root.querySelector('[data-opo-cmp-range]');
      if (!range) return;

      function setPos(pct) {
        var value = Math.max(0, Math.min(100, pct));
        root.style.setProperty('--opo-pos', value + '%');
        range.value = String(Math.round(value));
      }

      function fromEvent(event) {
        var rect = root.getBoundingClientRect();
        if (!rect.width) return;
        setPos(((event.clientX - rect.left) / rect.width) * 100);
      }

      range.addEventListener('input', function () { setPos(Number(range.value)); });

      var dragging = false;
      root.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        root.setPointerCapture(event.pointerId);
        root.classList.add('is-dragging');
        fromEvent(event);
      });
      root.addEventListener('pointermove', function (event) {
        if (dragging) fromEvent(event);
      });
      function stop(event) {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        if (root.hasPointerCapture(event.pointerId)) root.releasePointerCapture(event.pointerId);
      }
      root.addEventListener('pointerup', stop);
      root.addEventListener('pointercancel', stop);

      setPos(Number(range.value));
    });
  })();

  /* Índice: abierto en escritorio, plegado en móvil. Se renderiza abierto para
     que sin JavaScript el contenido siga completo. */
  (function () {
    var blocks = document.querySelectorAll('[data-opo-collapsible]');
    if (!blocks.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      blocks.forEach(function (el) {
        // en móvil se cierran todos: 45 filas seguidas son ilegibles en un
        // teléfono, y tres cabeceras dejan ver la estructura de un vistazo
        el.open = !mq.matches;
      });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  })();

  /* Barra de compra fija: aparece cuando el CTA del hero deja de verse. */
  (function () {
    var bar = document.querySelector('[data-opo-stickybuy]');
    var anchor = document.querySelector('.opo-main-actions [data-opoflow-buy-now]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        });
      },
      { threshold: 0.5, rootMargin: '0px 0px -90px 0px' }
    );
    io.observe(anchor);
  })();

  /* Cuenta atrás del precio de lanzamiento. */
  (function () {
    document.querySelectorAll('[data-opo-countdown]').forEach(function (root) {
      var target = Date.parse(root.getAttribute('data-opo-countdown'));
      if (isNaN(target)) return;
      var d = root.querySelector('[data-opo-d]');
      var h = root.querySelector('[data-opo-h]');
      var m = root.querySelector('[data-opo-m]');
      var s = root.querySelector('[data-opo-s]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = target - Date.now();
        if (left <= 0) { root.hidden = true; clearInterval(id); return; }
        var secs = Math.floor(left / 1000);
        d.textContent = pad(Math.floor(secs / 86400));
        h.textContent = pad(Math.floor((secs % 86400) / 3600));
        m.textContent = pad(Math.floor((secs % 3600) / 60));
        s.textContent = pad(secs % 60);
        root.hidden = false;
      }
      tick();
      var id = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opoflow-topbar"] && !Shopify.designMode) return;
  try {
    
  function initOpoMarquee() {
    document.querySelectorAll('[data-opo-marquee]').forEach(function(bar) {
      if (bar.dataset.marqueeReady) return;
      bar.dataset.marqueeReady = 'true';
      var button = bar.querySelector('[data-opo-marquee-pause]');
      if (!button) return;
      button.hidden = false;
      button.addEventListener('click', function() {
        var paused = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Reanudar desplazamiento' : 'Pausar desplazamiento');
        button.textContent = paused ? 'Reanudar desplazamiento' : 'Pausar desplazamiento';
        bar.style.setProperty('--opo-marquee-state', paused ? 'paused' : 'running');
      });
    });
  }
  initOpoMarquee();
  document.addEventListener('shopify:section:load', initOpoMarquee);

  } catch(e) { console.error(e); }
})();
})();
